module.exports = __webpack_public_path__ + "img/category-donation-bg-ffa.4d3e501.webp";